import React, { useState } from "react";
import { Form, Formik } from "formik";
import InputField from "shared/Formik/InputField";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import Button from "shared/Button";
import { initiateLogin } from "./actions";
import { Redirect } from "react-router-dom";
import ErrorHandling from "shared/ErrorHandling";
import cx from "classnames";
import styles from "./InitiateLogin.module.scss";

const InitiateLogin = () => {
  const { pendingGift: gift } = useSelector((s) => s.account);
  const dispatch = useDispatch();
  const [error, setError] = useState();
  const [redirect, setRedirect] = useState();

  if (redirect) {
    return (
      <Redirect
        to={{
          pathname: redirect
        }}
      />
    );
  }

  return (
    <div>
      <h2 className={styles.title}>
        {gift ? "Log in or register to redeem your Gift Subscription" : "Login"}
      </h2>
      <p className={styles.description}>
        Please enter your email address to continue.
      </p>
      <Formik
        initialValues={{
          email: ""
        }}
        validationSchema={Yup.object().shape({
          email: Yup.string()
            .email("Invalid email format")
            .required("Email address is required")
        })}
        onSubmit={(values, { setSubmitting }) => {
          dispatch(initiateLogin(values)).then(
            (data) => {
              if (!data) {
                setRedirect("/auth/login");
              } else {
                setRedirect("/auth/register");
              }
            },
            (err) => {
              setError(err);
              setSubmitting(false);
            }
          );
        }}
      >
        {({ isSubmitting, isValid, dirty }) => (
          <Form className={styles.form}>
            <InputField
              name="email"
              type="email"
              label="Email"
              className={styles.emailField}
            />
            <ErrorHandling error={error} />
            <Button
              type="submit"
              size="md"
              isLoading={isSubmitting}
              disabled={!dirty || !isValid}
            >
              Continue
            </Button>
          </Form>
        )}
      </Formik>
      <p className={styles.forgotPassword}>Forgot password?</p>
      <a
        className={cx(styles.link, styles.recoverLink)}
        href="/auth/forgot-password"
      >
        Click here to start recovering it.
      </a>
      <p className={styles.helpText}>
        Problems with accessing your account or logging in?{" "}
      </p>
      <p className={styles.contactText}>
        Please contact us at{" "}
        <a className={styles.link} href="mailto:shop@grind.co.uk">
          shop@grind.co.uk
        </a>
      </p>
    </div>
  );
};

export default InitiateLogin;
